<template>
    <div class="topic-selector">
        <div class="topic-selector__wrapper" v-touch:swipe.left="prev" v-touch:swipe.right="next">
            <div
                class="circle"
                :class="{
                    'flip-left-phase1': flipLeftPhase1,
                    'flip-left-middle': flipLeftMiddle,
                    'flip-right-phase1': flipRightPhase1,
                    'flip-right-middle': flipRightMiddle,
                    'flip-phase2': flipPhase2,
                }"
            >
                <img
                    src="../assets/icons/arrow-sections.svg"
                    alt="previous topic"
                    class="nav-arrow previous-arrow"
                    @click="next"
                />
                <div class="topic" @click="select(topicsData[currentTopicIndex].name)">
                    <div v-for="topic in topicsData" v-bind:key="topic.order">
                        <div v-if="currentTopicIndex === topic.order">
                            <img
                                :src="contextSrc(topic.iconSrc)"
                                alt="topic picture"
                                class="topic__pic"
                            />
                            <span class="topic__label">
                                {{ topic.title }}
                            </span>
                        </div>
                    </div>
                </div>
                <img
                    src="../assets/icons/arrow-sections.svg"
                    alt="next topic"
                    class="nav-arrow next-arrow"
                    @click="prev"
                />
            </div>
            <img
                @click="select(topicsData[currentTopicIndex].name)"
                src="../assets/icons/arrow.svg"
                alt="select topic"
                class="select-arrow"
                :class="{ disabled: disableSelectTopicBtn }"
            />
        </div>
    </div>
</template>

<script>
    import { topicsData } from '@/model/topics-data';

    export default {
        name: 'TopicSelector',
        data: function () {
            const picContext = require.context('../assets/topicPics/');
            return {
                topicsData,
                currentTopic: '',
                currentTopicIndex: 0,
                disableSelectTopicBtn: false,
                picContext,
                phaseDuration: 300,
                middleDuration: 15,
                isTransition: false,
                flipLeftPhase1: false,
                flipLeftMiddle: false,
                flipRightPhase1: false,
                flipRightMiddle: false,
                flipPhase2: false,
            };
        },
        mounted() {
            // Set currentTopicIndex base on current route
            const DEFAULT_TOPIC = 'zakupy';
            const { topic = DEFAULT_TOPIC } = this.$router.currentRoute.params;
            this.currentTopicIndex = this.topicsData.findIndex(({ name }) => name === topic);
            this.currentTopic = topic;
            this.disableSelect();
            if (this.$router.currentRoute.name === 'main') {
                this.disableSelectTopicBtn = false;
            }
        },
        watch: {
            $route({ params: { topic } }) {
                this.currentTopic = topic;
                this.disableSelectTopicBtn = topic === this.currentTopic;
                if (this.$router.currentRoute.name === 'main') {
                    this.disableSelectTopicBtn = false;
                }
            },
        },
        methods: {
            disableSelect() {
                const selectedTopic = this.topicsData[this.currentTopicIndex].name;
                this.disableSelectTopicBtn = selectedTopic === this.currentTopic;
            },
            contextSrc: function (imgSrc) {
                return this.picContext('./' + imgSrc);
            },
            prev: function () {
                if (this.isTransition) return;

                this.isTransition = false;
                this.flipLeftPhase1 = true;
                setTimeout(this.onPrevMiddleStart, this.phaseDuration);
            },
            next: function () {
                if (this.isTransition) return;
                this.isTransition = false;
                this.flipRightPhase1 = true;
                setTimeout(this.onNextMiddleStart, this.phaseDuration);
            },
            select: function (topic) {
                if (this.isTransition) return;
                if (this.disableSelectTopicBtn) return;
                this.$router.push({ name: 'topic', params: { topic } });
            },
            onPrevMiddleStart: function () {
                this.flipLeftMiddle = true;
                this.flipLeftPhase1 = false;
                this.currentTopicIndex--;
                if (this.currentTopicIndex < 0) {
                    this.currentTopicIndex = this.topicsData.length - 1;
                }
                setTimeout(this.onPrevMiddleEnd, this.middleDuration);
            },
            onPrevMiddleEnd: function () {
                this.flipPhase2 = true;
                this.flipLeftMiddle = false;
                setTimeout(this.onFlipEnd, this.phaseDuration);
            },
            onNextMiddleStart: function () {
                this.flipRightMiddle = true;
                this.flipRightPhase1 = false;
                this.currentTopicIndex++;
                if (this.currentTopicIndex >= this.topicsData.length) {
                    this.currentTopicIndex = 0;
                }
                setTimeout(this.onNextMiddleEnd, this.middleDuration);
            },
            onNextMiddleEnd: function () {
                this.flipPhase2 = true;
                this.flipRightMiddle = false;
                setTimeout(this.onFlipEnd, this.phaseDuration);
            },
            onFlipEnd: function () {
                this.flipPhase2 = false;
                this.isTransition = false;
                this.disableSelect();
            },
        },
    };
</script>

<style lang="scss">
    .topic-selector {
        position: relative;
        width: 68%;
        padding-top: 68%;

        &__wrapper {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            -webkit-transform: translate3d(0, 0, 0);
        }

        .topic {
            text-align: center;

            &__pic {
                display: block;
                margin-bottom: 10px;
            }

            &__label {
                color: $green;
                font-weight: bold;
            }
        }

        .nav-arrow {
            z-index: 10;
        }

        .previous-arrow {
            transform: scaleX(-1);
        }

        .select-arrow {
            &.disabled {
                filter: grayscale(1);
                user-select: none;
                pointer-events: none;
                touch-action: none;
            }
            position: absolute;
            width: 14%;
            left: 50%;
            bottom: 0;
            transform: translate3d(-50%, 50%, 1000px);
            z-index: 100;
            height: fit-content;

            //transform: translate3d(-15px, 15px, 1px);
        }

        .circle {
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            width: calc(100% - 44px);
            height: calc(100% - 44px);
            padding: 22px;
            border-radius: 50%;
            background-color: $white;
            perspective: 1000px;

            //----------------------------------------
            // LEFT FLIP CLASSES
            //----------------------------------------

            &.flip-left-phase1 {
                transform: rotate3d(0, 1, 0, -90deg);
                transition: transform 0.3s ease-in;

                .topic {
                    transform: translateX(-50%);
                    transition: transform 0.3s ease-in;
                }
            }

            &.flip-left-middle {
                transform: rotate3d(0, 1, 0, 90deg);

                .topic {
                    transform: translateX(50%);
                }
            }

            //----------------------------------------
            // RIGHT FLIP CLASSES
            //----------------------------------------

            &.flip-right-phase1 {
                transform: rotate3d(0, 1, 0, 90deg);
                transition: transform 0.3s ease-in;

                .topic {
                    transform: translateX(50%);
                    transition: transform 0.3s ease-in;
                }
            }

            &.flip-right-middle {
                transform: rotate3d(0, 1, 0, -90deg);

                .topic {
                    transform: translateX(-50%);
                }
            }

            //----------------------------------------
            // COMMON FLIP CLASSES
            //----------------------------------------

            &.flip-phase2 {
                transform: rotate3d(0, 1, 0, 0deg);
                transition: transform 0.3s ease-out;

                .topic {
                    transform: translateX(0);
                    transition: transform 0.3s;
                }
            }
        }
    }
</style>
